/**
 * 模块名称: 供应商管理 => 供应商管理
 * @author zhuyan@372163.com
 */

 import React from 'react'
 import { Switch, Route } from 'react-router-dom'
 import Association from './Association'
 import SupplierMgt from './SupplierMgt'
 
 const AssociationIndex = ({ match, history }) => {
 
     return (
         <Switch>
             <Route path={match.path + '/association'} component={Association} />
            <Route component={SupplierMgt} />
         </Switch>
     )
 }
 
 export default AssociationIndex